export default "__VITE_ASSET__CwUeSzcu__"